import { useEffect } from "react";
import Lenis from "lenis";
import { Route, Routes } from "react-router-dom";
import "@/App.css";
import { Toaster } from "@/components/ui/sonner";
import { Navbar } from "@/components/site/Navbar";
import { Hero } from "@/components/site/Hero";
import { EditorialMarquee } from "@/components/site/Marquee";
import { Services } from "@/components/site/Services";
import { GiftServices } from "@/components/site/GiftServices";
import { WhyChoose } from "@/components/site/WhyChoose";
import { PartnerForm } from "@/components/site/PartnerForm";
import { RiderForm } from "@/components/site/RiderForm";
import { DownloadApp } from "@/components/site/DownloadApp";
import { Contact } from "@/components/site/Contact";
import { DeleteAccount } from "@/components/site/DeleteAccount";
import { PrivacyPolicy } from "@/components/site/PrivacyPolicy";
import { Footer } from "@/components/site/Footer";
import { AdminApp } from "@/admin/AdminApp";
import { CustomerSite } from "@/customer/CustomerSite";

function PublicSite() {
  useEffect(() => {
    const prefersReduced = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;
    if (prefersReduced) return;

    const lenis = new Lenis({
      duration: 1.1,
      easing: (t) => Math.min(1, 1.001 - Math.pow(2, -10 * t)),
      smoothWheel: true,
    });

    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);

    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App min-h-screen bg-[#f4f7fb]">
      <Navbar />
      <main>
        <Hero />
        <EditorialMarquee />
        <Services />
        <GiftServices />
        <WhyChoose />
        <PartnerForm />
        <RiderForm />
        <DownloadApp />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}

function PublicLayout({ children }) {
  return (
    <div className="App min-h-screen bg-[#f4f7fb]">
      <Navbar />
      <main>
        {children}
      </main>
      <Footer />
    </div>
  );
}

function App() {
  return (
    <>
      <Routes>
        <Route path="/admin/*" element={<AdminApp />} />
        <Route path="/marketing" element={<PublicSite />} />
        <Route path="/about" element={<PublicSite />} />
        <Route path="/privacy-policy" element={<PublicLayout><PrivacyPolicy /></PublicLayout>} />
        <Route path="/delete-account" element={
          <PublicLayout>
            <DeleteAccount />
          </PublicLayout>
        } />
        <Route path="/*" element={<CustomerSite />} />
      </Routes>
      <Toaster position="top-center" richColors />
    </>
  );
}

export default App;
